import { render } from "./kanbanItem.vue?vue&type=template&id=1ef529c1&scoped=true"
import script from "./kanbanItem.vue?vue&type=script&lang=js"
export * from "./kanbanItem.vue?vue&type=script&lang=js"

import "./kanbanItem.vue?vue&type=style&index=0&id=1ef529c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef529c1"]])

export default __exports__